module.exports = __webpack_public_path__ + "static/media/time-zone-grey.6ee88aa4.svg";